/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.6.12
 */
import Tool from './Tool'
//
let { Polyline } = L;
/**
 * 线绘制工具
 */
export default class PolylineTool extends Tool {
  options = { feature: { color: 'red', weight: 2 } }

  /**
   * 启动
   */
  start() {
    this.onMouseDown = this.onMouseDown.bind(this)
    this.onMouseMove = this.onMouseMove.bind(this)
    let { map } = this;
    map.on('mousedown', this.onMouseDown);
    //
    this.restart = true;
  }
  /**
   * 取消
   */
  cancel() {
    let { map } = this;
    map.off('mousedown', this.onMouseDown);
    map.off('mousemove', this.onMouseMove);
    this.mp = null
  }
  /**
   * 绘制
   */
  onMouseDown(e) {
    this.reset();
    //
    let { marker, map, layer, options } = this;
    let { latlng } = e;
    //
    if (!marker) {
      marker = this.marker = new Polyline([latlng], options.feature).addTo(layer)
      map.on('mousemove', this.onMouseMove);
      map.once('dblclick', this.onEnd.bind(this))
    } else {
      this.mp = null
    }
  }
  /**
   * 
   * @param e 
   */
  onMouseMove(e) {
    let { marker, mp } = this;
    let { latlng } = e;
    if (!mp) {
      //
      marker.addLatLng(latlng);
      this.mp = latlng;
    } else {
      mp.lat = latlng.lat;
      mp.lng = latlng.lng;
      marker.getBounds().extend(mp)
      marker.redraw();
    }
  }

}


// WEBPACK FOOTER //
// ./src/plugins/tools/PolylineTool.js